import React, { useState, useEffect, Children } from "react";
import { EmployeeTeamVM, OverallKRA } from "../../Models/ViewModels";
import {
  Table,
  Pagination,
  Stack,
  Avatar,
  Input,
  Button,
  Toggle,
  Whisper,
  Tooltip,
  DatePicker,
} from "rsuite";
import * as xml2js from "xml2js";
import { parseString } from "xml2js";
import { Workbook } from "exceljs";
import * as TeamDB from "../../Services/EmployeeDB";
import { PageHeader } from "../../SharedComponents/PageHeader";
import * as XLSX from "xlsx";
import { handleDownloadAsExcel } from "../../Helpers/Utils";
import { GetUserLoginID } from "../../Services/UserSessionManager";
import { CustomTableCell } from "../../SharedComponents/CustomTableCell";
import { Alert, Modal } from "react-bootstrap";
import {
  DownloadExcelForOverallKRA,
  GetOverallKRAReport,
} from "../../Services/KRAApprovalDB";
import { BootstrapIcon } from "../../SharedComponents/BootstrapIcon";
import { CustomTableHeaderCells } from "../../SharedComponents/ToolTipForColumnGroup";
import { toast } from "react-toastify";
import moment from "moment";
import axios from "axios";
const { Column, ColumnGroup } = Table;
const colors = ["pink", "grey", "blue", "yellow", "purple", "green", "red"];

export const FinalKRAReport = ({ name, designation, department }: any) => {
  const proc: any = [];
  const proc1: any = [];
  const [cachedKRAList, setCachedKRAList] = useState(new Array<OverallKRA>());
  const [processName, setProcessName] = useState(new Array<OverallKRA>());
  const [sortColumn, setSortColumn] = useState();
  const [sortType, setSortType] = useState();
  const [isLoading, setLoading] = useState(true);
  const [page, setPage] = React.useState(1);
  const [limit, setLimit] = React.useState(15);
  const [filteredKRAList, setFilteredKRAList] = useState(
    new Array<OverallKRA>()
  );
  const [checked, setChecked] = useState(false);
  const [loginid, setLoginid] = useState(GetUserLoginID());
  const [date, setDate] = useState(new Date());
  const [teamMembers, setTeamMembers] = useState([]);
  const [searching, setSearching] = useState(false);
  const [show, hide] = useState(true);

  const api_url = process.env.REACT_APP_STEM_API_BASE_URL + "/api";
  useEffect(() => {
    let newDate = new Date();
    let date = newDate.getDate();
    let month1;
    let month = newDate.getMonth();
    if (month < 10) month1 = "0" + month;
    else month1 = month;
    let year = newDate.getFullYear();
    getAllTeamList(year + "/" + month1 + "/" + "01", loginid);
  }, []);

  const filterData = (val: string, e: any) => {
    let searchText = val;
    setPage(1);
    if (searchText) {
      setFilteredKRAList(
        cachedKRAList.filter((e) =>
          JSON.stringify(e).toLowerCase().includes(searchText.toLowerCase())
        )
      );
      setSearching(true);
    } else {
      setFilteredKRAList([...cachedKRAList]);
      setSearching(false);
    }
  };

  const tableDataFeed = filteredKRAList.filter((v, i) => {
    const start = limit * (page - 1);
    const end = start + limit;
    return i >= start && i < end;
  });

  const handleChangeLimit = (dataKey: any) => {
    setPage(1);
    setLimit(dataKey);
  };

  const getAllTeamList = (InputYear: any, loginid: any) => {
    GetOverallKRAReport(InputYear, loginid)
      .then((res) => {
        if (res.data) {
          for (let i = 0; i < res.data.length; i++) {
            res.data[i].TotalWeightage =
              res.data[i].Qualweightage +
              res.data[i].Fdbkweightage +
              res.data[i].Attendweightage +
              res.data[i].PKTweightage +
              res.data[i].Prodweightage;

            res.data[i].TotalAchieve =
              res.data[i].QualityAchieved +
              res.data[i].ProdAchieved +
              res.data[i].AttendAchieved +
              res.data[i].FdbkAchieved +
              res.data[i].PKTAchieved;
          }

          setCachedKRAList(res.data);
          setFilteredKRAList(res.data);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log("fail");
      });
  };

  const handleDownloadAsExcel = async (
    date: moment.MomentInput,
    loginid: string
  ) => {
    try {
      const inputYear = moment(date).format("YYYY-MM");
      const response = await DownloadExcelForOverallKRA(inputYear, loginid);
      const xmlData = response.data;
      const url = window.URL.createObjectURL(xmlData);
      const a = document.createElement("a");
      a.setAttribute("href", url);
      a.setAttribute("download", "OverAllKra.xlsx");
      a.click();
    } catch (error) {
      console.log(error);
    }
  };

  const handleSet = (date: Date) => {
    setDate(date);
    const dateFormatted = moment(date).format("YYYY-MM");
    setLoading(true);
    getAllTeamList(dateFormatted, loginid);
  };

  const handleSortColumn = (sortColumn: any, sortType: any) => {
    setTimeout(() => {
      setSortColumn(sortColumn);
      setSortType(sortType);
    }, 500);
    if (sortColumn && sortType) {
      return cachedKRAList.sort((a: any, b: any) => {
        let x = a[sortColumn];
        let y = b[sortColumn];
        if (typeof x === "string" || "") {
          x = x.charCodeAt();
        }
        if (typeof y === "string" || "") {
          y = y.charCodeAt();
        }
        if (sortType === "asc") {
          return x - y;
        } else {
          return y - x;
        }
      });
    }
  };
  return (
    <>
      <div className="row">
        <div className="col-md-6">
          <PageHeader title="OverAll KRA Report" backPage="">
            <></>
          </PageHeader>
        </div>

        <div className="col-md-2">
          <DatePicker
            oneTap
            format="yyyy-MM"
            value={date}
            onSelect={(date: Date) => handleSet(date)}
          />
        </div>

        <div className="col-md-3">
          <Input
            className="form-control w-100 "
            type="search"
            autoFocus={true}
            placeholder={"Search...."}
            onChange={filterData}
          />
        </div>

        <div className="col-md-1">
          {searching ? (
            <button
              id="color"
              onClick={() => handleDownloadAsExcel(date, loginid)}
            >
              <BootstrapIcon
                bootStrapIconName={"file-earmark-arrow-down-fill"}
                size={30}
                cssClasses={"pe-2"}
              />{" "}
            </button>
          ) : (
            <button
              id="color"
              onClick={() => handleDownloadAsExcel(date, loginid)}
            >
              <BootstrapIcon
                bootStrapIconName={"file-earmark-arrow-down-fill"}
                size={30}
                cssClasses={"pe-2"}
              />{" "}
            </button>
          )}
        </div>

        <hr />
      </div>

      <div>
        <div className="show-container">
          <Table
            id="table"
            height={450}
            data={tableDataFeed}
            sortColumn={sortColumn}
            sortType={sortType}
            onSortColumn={handleSortColumn}
            loading={isLoading}
            bordered={true}
            cellBordered={true}
            className="border border-dark mt-2"
            // autoHeight={true}
            rowHeight={34}
            headerHeight={60}
          >
            <Column align="center" width={150} fixed>
              <CustomTableHeaderCells>
                {" "}
                <Whisper followCursor speaker={<Tooltip>Name</Tooltip>}>
                  <span>Name</span>
                </Whisper>
              </CustomTableHeaderCells>
              <CustomTableCell dataKey="EmployeeName" />
            </Column>
            <Column width={100} align="center" fixed>
              <CustomTableHeaderCells>
                {" "}
                <Whisper followCursor speaker={<Tooltip>Location</Tooltip>}>
                  <span>Location</span>
                </Whisper>
              </CustomTableHeaderCells>
              <CustomTableCell dataKey="Location" />
            </Column>
            <Column width={150} align="center" fixed>
              <CustomTableHeaderCells>
                <Whisper followCursor speaker={<Tooltip>Designation</Tooltip>}>
                  <span>Designation</span>
                </Whisper>
              </CustomTableHeaderCells>
              <CustomTableCell dataKey="Designation" />
            </Column>
            <ColumnGroup header="KRA1 - Quality" align="center">
              <Column width={0} resizable>
                <CustomTableHeaderCells></CustomTableHeaderCells>
                <CustomTableCell></CustomTableCell>
              </Column>
              <Column width={50} resizable>
                <CustomTableHeaderCells>
                  <Whisper followCursor speaker={<Tooltip>Weightage</Tooltip>}>
                    <span>Weightage</span>
                  </Whisper>
                </CustomTableHeaderCells>
                <CustomTableCell dataKey="Qualweightage" />
              </Column>

              <Column width={50} resizable>
                <CustomTableHeaderCells>
                  <Whisper followCursor speaker={<Tooltip>Target</Tooltip>}>
                    <span>Target</span>
                  </Whisper>
                </CustomTableHeaderCells>
                <CustomTableCell dataKey="QualTarget" />
              </Column>

              <Column width={70} resizable>
                <CustomTableHeaderCells>
                  <Whisper followCursor speaker={<Tooltip> Actual</Tooltip>}>
                    <span> Actual</span>
                  </Whisper>
                </CustomTableHeaderCells>
                <CustomTableCell dataKey="QualityPercent" />
              </Column>
              <Column width={70} resizable>
                <CustomTableHeaderCells>
                  <Whisper followCursor speaker={<Tooltip>Achieved</Tooltip>}>
                    <span>Achieved</span>
                  </Whisper>
                </CustomTableHeaderCells>
                <CustomTableCell dataKey="QualityAchieved" />
              </Column>
              <Column width={70} resizable>
                <CustomTableHeaderCells>
                  <Whisper
                    followCursor
                    speaker={<Tooltip> KRA Rating</Tooltip>}
                  >
                    <span> KRA Rating</span>
                  </Whisper>
                </CustomTableHeaderCells>
                <CustomTableCell dataKey="QualityRating" />
              </Column>
            </ColumnGroup>
            <ColumnGroup header="KRA2 - Productivity" align="center">
              <Column width={0} resizable>
                <CustomTableHeaderCells></CustomTableHeaderCells>
                <CustomTableCell></CustomTableCell>
              </Column>
              <Column width={50} resizable>
                <CustomTableHeaderCells>
                  {" "}
                  <Whisper followCursor speaker={<Tooltip>Weightage</Tooltip>}>
                    <span>Weightage</span>
                  </Whisper>
                </CustomTableHeaderCells>
                <CustomTableCell dataKey="Prodweightage" />
              </Column>
              <Column width={50} resizable>
                <CustomTableHeaderCells>
                  <Whisper followCursor speaker={<Tooltip>Target</Tooltip>}>
                    <span>Target</span>
                  </Whisper>
                </CustomTableHeaderCells>
                <CustomTableCell dataKey="ProdTarget" />
              </Column>
              <Column width={70} resizable>
                <CustomTableHeaderCells>
                  <Whisper followCursor speaker={<Tooltip> Actual</Tooltip>}>
                    <span> Actual</span>
                  </Whisper>
                </CustomTableHeaderCells>
                <CustomTableCell dataKey="ProductionCount" />
              </Column>
              <Column width={70} resizable>
                <CustomTableHeaderCells>
                  <Whisper followCursor speaker={<Tooltip>Achieved</Tooltip>}>
                    <span>Achieved</span>
                  </Whisper>
                </CustomTableHeaderCells>
                <CustomTableCell dataKey="ProdAchieved" />
              </Column>
              <Column width={70} resizable>
                <CustomTableHeaderCells>
                  <Whisper
                    followCursor
                    speaker={<Tooltip> KRA Rating</Tooltip>}
                  >
                    <span> KRA Rating</span>
                  </Whisper>
                </CustomTableHeaderCells>
                <CustomTableCell dataKey="ProductivityRating" />
              </Column>
            </ColumnGroup>
            <ColumnGroup header="KRA3 - Attendance" align="center">
              <Column width={0} resizable>
                <CustomTableHeaderCells></CustomTableHeaderCells>
                <CustomTableCell></CustomTableCell>
              </Column>
              <Column width={50} resizable>
                <CustomTableHeaderCells>
                  {" "}
                  <Whisper followCursor speaker={<Tooltip>Weightage</Tooltip>}>
                    <span>Weightage</span>
                  </Whisper>
                </CustomTableHeaderCells>
                <CustomTableCell dataKey="Attendweightage" />
              </Column>
              <Column width={50} resizable>
                <CustomTableHeaderCells>
                  <Whisper followCursor speaker={<Tooltip>Target</Tooltip>}>
                    <span>Target</span>
                  </Whisper>
                </CustomTableHeaderCells>
                <CustomTableCell dataKey="BaseAttendance" />
              </Column>
              <Column width={70} resizable>
                <CustomTableHeaderCells>
                  <Whisper followCursor speaker={<Tooltip> Actual</Tooltip>}>
                    <span> Actual</span>
                  </Whisper>
                </CustomTableHeaderCells>
                <CustomTableCell dataKey="FullPresent" />
              </Column>
              <Column width={70} resizable>
                <CustomTableHeaderCells>
                  <Whisper followCursor speaker={<Tooltip>Achieved</Tooltip>}>
                    <span>Achieved</span>
                  </Whisper>
                </CustomTableHeaderCells>
                <CustomTableCell dataKey="AttendAchieved" />
              </Column>
              <Column width={70} resizable>
                <CustomTableHeaderCells>
                  <Whisper
                    followCursor
                    speaker={<Tooltip> KRA Rating</Tooltip>}
                  >
                    <span> KRA Rating</span>
                  </Whisper>
                </CustomTableHeaderCells>
                <CustomTableCell dataKey="AttendanceRating" />
              </Column>
            </ColumnGroup>
            <ColumnGroup header="KRA4 - Manager Feedback" align="center">
              <Column width={0} resizable>
                <CustomTableHeaderCells></CustomTableHeaderCells>
                <CustomTableCell></CustomTableCell>
              </Column>
              <Column width={50} resizable>
                <CustomTableHeaderCells>
                  {" "}
                  <Whisper followCursor speaker={<Tooltip>Weightage</Tooltip>}>
                    <span>Weightage</span>
                  </Whisper>
                </CustomTableHeaderCells>
                <CustomTableCell dataKey="Fdbkweightage" />
              </Column>
              <Column width={50} resizable>
                <CustomTableHeaderCells>
                  <Whisper followCursor speaker={<Tooltip>Target</Tooltip>}>
                    <span>Target</span>
                  </Whisper>
                </CustomTableHeaderCells>
                <CustomTableCell dataKey="FdbkTarget" />
              </Column>
              <Column width={70} resizable>
                <CustomTableHeaderCells>
                  <Whisper followCursor speaker={<Tooltip> Actual</Tooltip>}>
                    <span> Actual</span>
                  </Whisper>
                </CustomTableHeaderCells>
                <CustomTableCell dataKey="Feedback" />
              </Column>
              <Column width={70} resizable>
                <CustomTableHeaderCells>
                  <Whisper followCursor speaker={<Tooltip>Achieved</Tooltip>}>
                    <span>Achieved</span>
                  </Whisper>
                </CustomTableHeaderCells>

                <CustomTableCell dataKey="FdbkAchieved" />
              </Column>
            </ColumnGroup>
            <ColumnGroup header="KRA5 - Process Knowledge Test" align="center">
              <Column width={0} resizable>
                <CustomTableHeaderCells></CustomTableHeaderCells>
                <CustomTableCell></CustomTableCell>
              </Column>
              <Column width={50} resizable>
                <CustomTableHeaderCells>
                  {" "}
                  <Whisper followCursor speaker={<Tooltip>Weightage</Tooltip>}>
                    <span>Weightage</span>
                  </Whisper>
                </CustomTableHeaderCells>
                <CustomTableCell dataKey="PKTweightage" />
              </Column>
              <Column width={50} resizable>
                <CustomTableHeaderCells>
                  <Whisper followCursor speaker={<Tooltip>Target</Tooltip>}>
                    <span>Target</span>
                  </Whisper>
                </CustomTableHeaderCells>
                <CustomTableCell dataKey="PKTTarget" />
              </Column>
              <Column width={70} resizable>
                <CustomTableHeaderCells>
                  <Whisper followCursor speaker={<Tooltip> Actual</Tooltip>}>
                    <span> Actual</span>
                  </Whisper>
                </CustomTableHeaderCells>
                <CustomTableCell dataKey="Percentage" />
              </Column>
              <Column width={70} resizable>
                <CustomTableHeaderCells>
                  <Whisper followCursor speaker={<Tooltip>Achieved</Tooltip>}>
                    <span>Achieved</span>
                  </Whisper>
                </CustomTableHeaderCells>

                <CustomTableCell>
                  {(rowData: any) => {
                    return <p>{rowData.PKTAchieved}</p>;
                  }}
                </CustomTableCell>
              </Column>
              <Column width={70} resizable>
                <CustomTableHeaderCells>
                  <Whisper
                    followCursor
                    speaker={<Tooltip> KRA Rating</Tooltip>}
                  >
                    <span> KRA Rating</span>
                  </Whisper>
                </CustomTableHeaderCells>
                <CustomTableCell dataKey="PKTRating" />
              </Column>
            </ColumnGroup>
            <ColumnGroup header="Total Score" align="center">
              <Column width={50} resizable>
                <CustomTableHeaderCells>
                  {" "}
                  <Whisper
                    followCursor
                    speaker={<Tooltip>Total Weightage</Tooltip>}
                  >
                    <span>Total Weightage</span>
                  </Whisper>
                </CustomTableHeaderCells>
                <CustomTableCell dataKey="TotalWeightage" />
              </Column>
              <Column width={50} resizable>
                <CustomTableHeaderCells>
                  <Whisper
                    followCursor
                    speaker={<Tooltip>Total Achieved</Tooltip>}
                  >
                    <span>Total Achieved</span>
                  </Whisper>
                </CustomTableHeaderCells>

                <CustomTableCell dataKey="TotalAchieve" />
              </Column>

              <Column width={70} resizable>
                <CustomTableHeaderCells>
                  <Whisper
                    followCursor
                    speaker={<Tooltip> KRA Rating</Tooltip>}
                  >
                    <span> KRA Rating</span>
                  </Whisper>{" "}
                </CustomTableHeaderCells>

                <CustomTableCell dataKey="OverallKRARating" />
              </Column>
            </ColumnGroup>
          </Table>
          {filteredKRAList && (
            <div style={{ padding: 20 }}>
              <Pagination
                prev
                next
                first
                last
                ellipsis
                boundaryLinks
                maxButtons={5}
                size="md"
                layout={["total", "-", "limit", "|", "pager", "skip"]}
                total={filteredKRAList.length}
                limitOptions={[10, 15, 20, 30]}
                limit={limit}
                activePage={page}
                onChangePage={setPage}
                onChangeLimit={handleChangeLimit}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};
